import { createGlobalStyle } from 'styled-components'

const ScrollSuppressor = createGlobalStyle`
    body,
    html {
        overflow: ${({ suppress }) => (suppress ? 'hidden' : 'auto')};
    }
`

export default ScrollSuppressor
